import { render, staticRenderFns } from "./MultipleCardsView.vue?vue&type=template&id=0e784e9a&"
import script from "./MultipleCardsView.vue?vue&type=script&lang=js&"
export * from "./MultipleCardsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports